(function () {
  'use strict';

  angular
    .module('app.product', [])

    /* @ngInject */
    .directive('productDetail', function () {
      return {
        restrict: 'E',
        scope: false,
        bindToController: {
          id: '<idProduct',
          url: '@productUrl',
          idGroup: '<idProductGroup',
          urlGroup: '@productGroupUrl',
          isPrimary: '<',
          isKit: '<',
          showComponents: '<',
          allowAddToCart: '<',
          min: '<',
          step: '<',
          designation: '@productDesignation',
          img: '<productImg',
          modalCtrl: '<',
          device: '<',
          js: '@'
        },
        controllerAs: 'productCtrl',
        /* @ngInject */
        controller: ["$scope", "LoadService", function ($scope, LoadService) {
          var ctrl = this;

          ctrl.quantity = 1;
          ctrl.costTTC = 0;
          ctrl.costHT = 0;
          ctrl.customizationCostTTC = 0;
          ctrl.customizationCostHT = 0;

          ctrl.$onInit = function () {
            LoadService.getService('AsyncProductService', { ctrl: ctrl, scope: $scope }, 'initModule');
          };
        }]
      };
    })

    /* @ngInject */
    .directive('productAdvice', function () {
      return {
        restrict: 'E',
        scope: false,
        bindToController: {
          js: '@'
        },
        controllerAs: 'productCtrl',
        /* @ngInject */
        controller: ["$scope", "LoadService", function ($scope, LoadService) {
          var ctrl = this;
          ctrl.$onInit = function () {
            LoadService.getService('AsyncProductService', { ctrl: ctrl });
          };
        }]
      };
    });
})();
